import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../components/common/SafeIcon';
import BrandLogo from '../components/common/BrandLogo';

export default function PublicLanding() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-32 relative overflow-hidden">
      {/* Brand Shapes */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-brand-cyan/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-brand-gold/5 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="relative z-10 max-w-4xl">
        <div className="flex items-center justify-center mb-12">
          <BrandLogo size="hero" />
        </div>
        
        <h1 className="text-3xl md:text-5xl font-black text-[var(--text-main)] mb-8 tracking-tight uppercase italic leading-none transition-colors">
          El Movimiento que está <br className="hidden md:block" />
          <span className="gfi-gradient-text">cambiando la historia</span>
        </h1>
        
        <p className="text-lg md:text-xl text-[var(--text-secondary)] mb-12 leading-relaxed max-w-2xl mx-auto font-medium transition-colors">
          Unidos para entrenar, reconocer y dar identidad a los líderes latinos en el mundo financiero.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => navigate('/login')}
            className="gfi-gradient-bg text-brand-navy px-10 py-5 rounded-full font-black text-sm uppercase tracking-[0.2em] transition-all transform hover:scale-105 shadow-2xl flex items-center justify-center gap-3"
          >
            Entrar a la Plataforma <SafeIcon name="ArrowRight" className="w-5 h-5" />
          </button>
          <button 
            onClick={() => navigate('/blog')}
            className="bg-[var(--bg-surface)] text-[var(--text-main)] border border-[var(--border-subtle)] px-10 py-5 rounded-full font-black text-sm uppercase tracking-[0.2em] transition-all hover:bg-[var(--border-subtle)] flex items-center justify-center"
          >
            Leer el Blog
          </button>
        </div>
        
        <div className="mt-32 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="flex flex-col items-center">
            <span className="text-3xl font-black text-[var(--text-main)]">500+</span>
            <span className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-secondary)] mt-2">Agentes</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-3xl font-black text-[var(--text-main)]">12</span>
            <span className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-secondary)] mt-2">Estados</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-3xl font-black text-[var(--text-main)]">100%</span>
            <span className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-secondary)] mt-2">En Español</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-3xl font-black text-[var(--text-main)]">$1M+</span>
            <span className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-secondary)] mt-2">Impacto</span>
          </div>
        </div>
      </div>
    </div>
  );
}